import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';
import { EntityType, FeatureType } from 'common/types';

const useNewAlivenessFeatureFlag = (entityType: EntityType | FeatureType, entityId: string) => {
  const isProdEnv = process.env.APP_ENV === 'production';
  const featureFlagName = 'merchant_admin_insights_v2_new_aliveness_enabled';
  const { user, isEmployee } = useUser();
  const { locale } = useIntl();

  const { data: featureFlags, isLoading } = useFeatureFlags(
    [featureFlagName],
    {
      user_id: user?.id || '',
      user_email: user?.email || '',
      user_country: user?.country || '',
      is_employee: isEmployee,
      locale,
      ...(entityType ? { feature: entityType } : {}),
      ...(entityId ? { feature_id: entityId } : {}),
    },
    {
      enabled: isProdEnv,
    },
  );

  if (!isProdEnv) {
    return {
      isLoading: false,
      isNewAlivenessEnabled: true,
    };
  }

  return {
    isLoading,
    isNewAlivenessEnabled: featureFlags?.[featureFlagName] === 'on',
  };
};

export default useNewAlivenessFeatureFlag;
